export function navigatorShare(dataToShare) {
  if (dataToShare) navigator.share(dataToShare);
}

export function isShareEnabled() {
  return !!(typeof navigator !== 'undefined' && navigator.share);
}
